"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var FormatText_1 = __importDefault(require("../components/FormatText"));
var notification = {
    success: function (text, title) {
        return antd_1.notification.success({
            message: title ? react_1.default.createElement(FormatText_1.default, { id: title }) : react_1.default.createElement(FormatText_1.default, { id: "ui.commons.notification.success" }),
            description: react_1.default.createElement(FormatText_1.default, { id: text }),
        });
    },
    error: function (text, title) {
        return antd_1.notification.error({
            message: title ? react_1.default.createElement(FormatText_1.default, { id: title }) : react_1.default.createElement(FormatText_1.default, { id: "ui.commons.notification.error" }),
            description: react_1.default.createElement(FormatText_1.default, { id: text }),
        });
    },
    info: function (text, title) {
        return antd_1.notification.info({
            message: title ? react_1.default.createElement(FormatText_1.default, { id: title }) : react_1.default.createElement(FormatText_1.default, { id: "ui.commons.notification.information" }),
            description: react_1.default.createElement(FormatText_1.default, { id: text }),
        });
    },
    warn: function (text, title) {
        return antd_1.notification.warn({
            message: title ? react_1.default.createElement(FormatText_1.default, { id: title }) : react_1.default.createElement(FormatText_1.default, { id: "ui.commons.notification.warning" }),
            description: react_1.default.createElement(FormatText_1.default, { id: text }),
        });
    },
    destroy: function () {
        antd_1.notification.destroy();
    },
};
exports.default = notification;
